<template>
  <div>
    <div class="content-input" style="margin-bottom: 16px">
      <div>
        <label>登录设备：</label>
        <el-select v-model="emulatorState" placeholder="Select" style="width: 8em" >
          <el-option v-for="item in emulatorStateArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="margin-left: 16px">
        <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%"
        v-loading="listLoading"
        border
    >
      <el-table-column property="loginTime" label="登录时间"/>
      <el-table-column property="createTime" label="登录设备">
        <template #default="scope">
          {{scope.row.state == 1?'模拟器':scope.row.state == 2?'真机':''}}
        </template>
      </el-table-column>
      <el-table-column property="logoutTime" label="登出时间"/>
      <el-table-column property="dayNum" label="使用天数"/>
    </el-table>
    <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import {getEmulatorDetailPageList} from '@/api/url'
import { getFormData } from '@/api/api'
export default {
  name: "enterFreeList",
  props: {
    value: Object
  },
  data() {
    return {
      phone: this.value.phone,
      userId: this.value.userId,
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,
      // 登录设备
      emulatorStateArray: [
        {label: '不限', value: -1},
        {label: '模拟器', value: 1},
        {label: '真机', value: 2},
      ],
      emulatorState: -1,
    }
  },
  methods: {

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.userId;
      param['state'] = this.emulatorState;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getEmulatorDetailPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

  },
  mounted() {
    this.getPage()
  }
}
</script>

<style scoped>

</style>
